import { render } from "./MyNotes.vue?vue&type=template&id=1e6afa38"
import script from "./MyNotes.ts?vue&type=script&lang=js&external"
export * from "./MyNotes.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__